import React, { useEffect, useState } from "react";

import {
  contentCards,
  IContentCardSlim,
  IContentCardsResult,
  isContentCardSlim,
} from "@origin-digital/event-dispatcher";
import { SlimCardWidget } from "@origin-digital/personalisation-widget";
import { StackSection } from "@origin-digital/ods-core";
import styled from "styled-components";

const SlimCardWrapper = styled.div`
  [data-id="content-card-dismiss"] {
    background: none;
  }
  [data-id="content-card--slim"] {
    border-color: ${({ theme }) => theme.palette.borderColor.primary};
  }
`;

export const SlimCard = () => {
  const location = "helpSupport-landing";
  const [cardContent, setCardContent] = useState<IContentCardSlim>();

  useEffect(() => {
    contentCards({ location, limit: 1 }).then(
      ({ cards }: IContentCardsResult) => {
        const [card] = cards;
        if (isContentCardSlim(card)) {
          setCardContent(card);
        }
      }
    );
  }, [location]);

  if (!cardContent) {
    return null;
  }

  return (
    <StackSection paddingY="none" width={"xlarge"}>
      <SlimCardWrapper>
        <SlimCardWidget {...cardContent} />
      </SlimCardWrapper>
    </StackSection>
  );
};
